import React from "react";
import PropTypes from "prop-types";
import ZipcodeErrorState from "./ZipcodeErrorState";
import { FormattedMessage } from "react-intl";
import { ValidateFiveDigitCode } from "../../../utils/Helpers/USPostalCodeValidator";

const InputZipcodeForChargerCatalog = ({
     zipcode,
     setZipcode,
     handleSubmit,
     workingZipcode,
     id,
     isUpdating,
     isNotFound,
     showButtonBelow,
     showButtonInline,
     hideValidateRequest,
     userLocation,
}) => {
     const zipcodeIsValid = ValidateFiveDigitCode(workingZipcode);
     const zipcodeIsSynced = workingZipcode === zipcode;
     const isInvalid = !isUpdating && (!zipcodeIsValid || (zipcodeIsSynced && isNotFound));
     const idAria = id + " help";
     const showButton = showButtonBelow || showButtonInline;
     const { municipality, region, postcode } = userLocation || {};
     let formattedLocation = "";
     if (municipality && region && postcode) {
          const stateAbbreviations = {
               Alabama: "AL",
               Alaska: "AK",
               Arizona: "AZ",
               Arkansas: "AR",
               California: "CA",
               Colorado: "CO",
               Connecticut: "CT",
               Delaware: "DE",
               Florida: "FL",
               Georgia: "GA",
               Hawaii: "HI",
               Idaho: "ID",
               Illinois: "IL",
               Indiana: "IN",
               Iowa: "IA",
               Kansas: "KS",
               Kentucky: "KY",
               Louisiana: "LA",
               Maine: "ME",
               Maryland: "MD",
               Massachusetts: "MA",
               Michigan: "MI",
               Minnesota: "MN",
               Mississippi: "MS",
               Missouri: "MO",
               Montana: "MT",
               Nebraska: "NE",
               Nevada: "NV",
               "New Hampshire": "NH",
               "New Jersey": "NJ",
               "New Mexico": "NM",
               "New York": "NY",
               "North Carolina": "NC",
               "North Dakota": "ND",
               Ohio: "OH",
               Oklahoma: "OK",
               Oregon: "OR",
               Pennsylvania: "PA",
               "Rhode Island": "RI",
               "South Carolina": "SC",
               "South Dakota": "SD",
               Tennessee: "TN",
               Texas: "TX",
               Utah: "UT",
               Vermont: "VT",
               Virginia: "VA",
               Washington: "WA",
               "West Virginia": "WV",
               Wisconsin: "WI",
               Wyoming: "WY",
          };

          const regionAbbreviation =
               stateAbbreviations[region] ||
               region
                    .split(" ")
                    .map((w) => w[0])
                    .join("")
                    .toUpperCase();

          formattedLocation = `${municipality.toUpperCase()}, ${regionAbbreviation} (${postcode})`;
     }

     const handleKeyDown = (e) => {
          if (e.key === "Enter") {
               handleSubmit();
          }
     };

     const inputClassName = isUpdating
          ? "form-control"
          : `form-control${isInvalid ? " is-invalid" : ""}${zipcodeIsSynced && !isNotFound ? " is-valid" : ""}`;

     const renderButton = (
          <button
               type="button"
               className="btn btn-default mb-2"
               onClick={() => setZipcode(workingZipcode)}
               disabled={isUpdating}
               id="update-zipcode-button"
          >
               Go
          </button>
     );

     const renderError = (
          <ZipcodeErrorState
               zipcode={zipcode}
               workingZipcode={workingZipcode}
               isValid={zipcodeIsValid}
               isSynced={zipcodeIsSynced}
               isUpdating={isUpdating}
               isNotFound={isNotFound}
               hideValidateRequest={hideValidateRequest}
          />
     );

     return (
          <>
               <div className="input-zipcode-chargers-catalog-location-container">
                    <h3>
                         <FormattedMessage id="yourLocation" defaultMessage="Your Location" />:
                    </h3>
                    <h4>{formattedLocation}</h4>
               </div>
               <div
                    className={
                         showButtonInline
                              ? "form-inline input-zipcode-chargers-catalog"
                              : "input-zipcode-chargers-catalog"
                    }
               >
                    {!showButtonInline && (
                         <label htmlFor={id} className="modify-charger-incentives-label">
                              <FormattedMessage id="zipcode" defaultMessage="ZIP code" />
                         </label>
                    )}
                    <div className={`input-group mb-2${showButtonInline ? " mr-sm-2" : ""}`}>
                         <input
                              id={id}
                              className={inputClassName}
                              aria-describedby={idAria}
                              value={workingZipcode}
                              disabled={isUpdating}
                              onChange={(e) => setZipcode(e.target.value)}
                              onBlur={(e) => setZipcode(e.target.value)}
                              onKeyDown={(e) => handleKeyDown(e)}
                         />
                    </div>
                    {(showButtonBelow || !showButtonInline) && renderError}
                    {showButton && renderButton}
               </div>
               {showButtonInline && renderError}
          </>
     );
};

export default InputZipcodeForChargerCatalog;

InputZipcodeForChargerCatalog.propTypes = {
     zipcode: PropTypes.string,
     setZipcode: PropTypes.func,
     handleSubmit: PropTypes.func,
     workingZipcode: PropTypes.string,
     id: PropTypes.string,
     isUpdating: PropTypes.bool,
     isNotFound: PropTypes.bool,
     showButtonBelow: PropTypes.bool,
     showButtonInline: PropTypes.bool,
     hideValidateRequest: PropTypes.bool,
};
